module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.5caa4f4e.png";